import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Result, Card, Button } from 'antd-mobile'
import { Container, Header, Wrapper } from '../../../components_renew/Layout'
import { handleCatch } from '../../../utils'
import OrderPayImg from '../../../assets/img/order-pay-img.png'
import { setOrderListIndex, setOrderListRefresh } from '../../../actions/mallAction'
import { withTranslation } from 'react-i18next'

@withTranslation()
@withRouter
@connect()
class OrderPay extends React.PureComponent {

  state = {
    data: { totalPrice: '-' }
  }

  componentDidMount () {
    const { orderId } = this.props.match.params
    if (orderId) {
      this.requestOrderPayData(orderId)
    } else {
      window.toast.fail('订单号错误', 1, () => {
        this.props.history.goBack()
      })
    }
  }

  render () {
    let { orderId } = this.props.match.params
    let { totalPrice } = this.state.data
    const { t } = this.props
    return <Container>
      <Header>{t('order.pay')}</Header>
      <Wrapper>
        {/*{*/}
        {/*  orderId*/}
        {/*    ? <Result*/}
        {/*      imgUrl={OrderPayImg}*/}
        {/*      style={{ marginTop: 40, padding: '100px 0' }}*/}
        {/*      title={`${totalPrice} 元`}*/}
        {/*      message={`订单编号： ${orderId}`}*/}
        {/*      buttonText={'确认付款'}*/}
        {/*      buttonType={'ghost'}*/}
        {/*      onButtonClick={this.onClick}*/}
        {/*    />*/}
        {/*    : <Result*/}
        {/*      style={{ marginTop: 40, padding: '100px 0' }}*/}
        {/*      title={<FontAwesomeIcon icon={'times-circle'} />}*/}
        {/*      message={'订单信息有误'}*/}
        {/*    />*/}
        {/*}*/}
        <Card>
          <Result
            icon={<img src={OrderPayImg} alt=""/>}
            title={`${totalPrice} 元`}
            description={`${t('order.num')}： ${orderId}`}
            buttonText={t('order.pay')}
            buttonType={'ghost'}
            onButtonClick={this.onClick}
          />
          <div className={'my-8 mx-4'}>
            <Button
              block
              color={'primary'}
              fill={'outline'}
              onClick={this.onClick}>
              {t('order.pay')}
            </Button>
          </div>

        </Card>
      </Wrapper>
    </Container>
  }

  onClick = () => {
    let { orderId } = this.props.match.params
    if (!orderId) {
      window.toast.fail('订单号错误', 1)
      return
    }
    let config = {
      method: 'post',
      url: window.API.Mall.postPay,
      data: { orderNum: orderId }
    }
    window.toast.show('付款中...')
    window.axios.request(config)
      .then(() => {
        // todo 修改成modal确认
        this.props.dispatch(setOrderListRefresh())
        this.props.dispatch(setOrderListIndex('all'))
        window.toast.success('支付成功！', 1, () => {
          setTimeout(() => {
            this.props.history.replace(window.PATH.MALL_ORDER_LIST)
          })
        })
      })
      .catch(handleCatch)
  }

  // request
  requestOrderPayData = (orderId) => {
    let config = { url: window.API.Mall.getOrderDetails(orderId) }
    window.toast.show()
    window.axios.request(config)
      .then(res => {
        this.setState({ data: res })
        window.toast.hide()
      })
      .catch(handleCatch)
  }
}

export { OrderPay }
